// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610130545/js/" + chunkId + "." + {"44":"3ac773f5","225":"f1a0b337","481":"1297fa83","486":"04bf277f","770":"eb5cbc17"}[chunkId] + ".0.14750873525203145.chunk.js";
};